export default class SimpleCache {
    private cachedData: Record<string, any> = {};

    /**
     * Stores data in the cache.
     * @param key - The key for the cache entry, which can be a string, number, or object.
     * @param payload - The data to store in the cache.
     */
    public setCache(key: string | number | object, payload: any): void {
        const cacheKey = this.prepareKey(key);
        this.cachedData[cacheKey] = payload;
    }

    /**
     * Retrieves data from the cache.
     * @param key - The key for the cache entry, which can be a string, number, or object.
     * @returns The cached data if found, otherwise `undefined`.
     */
    public getCache(key: string | number | object): any {
        const cacheKey = this.prepareKey(key);
        return this.cachedData.hasOwnProperty(cacheKey) ? this.cachedData[cacheKey] : undefined;
    }

    /**
     * Clears all data in the cache.
     */
    public flush(): void {
        this.cachedData = {};
    }

    /**
     * Prepares a string key for caching based on the input.
     * @param data - The input key, which can be a string, number, or object.
     * @returns A string representation of the key.
     * @throws If the data type is not supported.
     */
    private prepareKey(data: string | number | object): string {
        if (typeof data === 'string') {
            return data;
        }

        if (typeof data === 'number') {
            return data.toString();
        }

        if (typeof data === 'object' && data !== null) {
            return Object.keys(data)
                .map((key) => `${key}:${data[key]}`)
                .join('::');
        }

        throw new Error('Data is not cacheable');
    }
}

